import { Injectable, ErrorHandler } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { environment } from 'src/environments/environment';

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    if (environment.production) {
      Sentry.captureException(error, {
        tags: {
          section: 'global_error_handler'
        }
      });
      console.error('Error global capturado por Sentry:', error);
    } else {
      console.error('Error global (Sentry deshabilitado en desarrollo):', error);
    }
  }
}
